import { Playground } from "docz";
import { Translator, TextHook2 as TextHook } from "../../../../../docz/components";
import React from 'react';
export default {
  Playground,
  Translator,
  TextHook,
  React
};